import React from "react";

import { styled } from "@mui/material";

interface BreakpointsProps {
  children?: React.ReactNode;
}

export const Breakpoints = ({ children }: BreakpointsProps) => {
  return <Container className="ig-dp-breakpoint-row">{children}</Container>;
};

const Container = styled("div")({
  width: "100%",
});
